import React from "react";
import { Select, Checkbox, Tooltip, Form } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 10 },
  },
};

class HotelDropdown extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.hotelSelect !== nextProps.hotelSelect ||
      this.props.hotelList !== nextProps.hotelList
    );
  }

  render() {
    const hotelStyles = this.props.hotelStyles
      ? this.props.hotelStyles
      : formItemLayout;
    return (
      <Form.Item
        {...hotelStyles}
        label={this.props.label !== undefined ? this.props.label : "Hotel Name"}
      >
        <Select
          placeholder={
            this.props.hotelPlaceholder
              ? this.props.hotelPlaceholder
              : this.props.multiple !== undefined && this.props.multiple
              ? "Please Select Hotel(s)"
              : "Please Select Hotel"
          }
          onChange={this.props.handleHotelChange}
          style={{ width: "100%", maxWidth: "450px" }}
          value={this.props.hotelSelect}
          mode={
            this.props.multiple !== undefined && this.props.multiple
              ? "multiple"
              : "single"
          }
          showSearch
          allowClear={
            this.props.allowClear !== undefined ? this.props.allowClear : false
          }
          // {...(typeof this.props.disabled==='boolean')?{'disabled':}:''}
          // {...typeof this.props.disabled==='boolean'?disabled:undefined}
          disabled={
            typeof this.props.disabled === "boolean"
              ? this.props.disabled
              : false
          }
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
        >
          {this.props.hotelList !== null
            ? this.props.hotelList.map((elem) => {
                return (
                  <Option key={elem.id} value={elem.id}>
                    {elem.hotel_code + " - " + elem.name}
                  </Option>
                );
              })
            : null}
        </Select>
        {typeof this.props.hotelTooltip === "string" ? (
          <Tooltip
            placement="topLeft"
            title={this.props.hotelTooltip}
            arrowPointAtCenter
          >
            <ExclamationCircleOutlined
              style={{ color: "red", marginLeft: 10 }}
            />
          </Tooltip>
        ) : null}
      </Form.Item>
    );
  }
}

export default HotelDropdown;
